module.exports = __webpack_public_path__ + "img/bonus_light_ru.8211c497.svg";